// ============================================================================
// KRUSKAL'S MST - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'kruskals',
  name: 'Kruskal\'s MST',
  category: 'Graphs',
  complexity: {
    time: 'O(E log E)',
    space: 'O(V)'
  },
  description: 'A minimum spanning tree algorithm that uses a greedy approach. It sorts all edges by weight and adds them to the MST if they connect two previously disconnected components, using Union-Find for cycle detection.'
};
